// specialLogos.js
var SpecialLogos = pc.createScript('specialLogos');

// initialize code called once per entity
SpecialLogos.prototype.initialize = function() {
   // this.app.on('userInput:test', this.checkVisibility, this);
    this.ents = this.entity.children;
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.piScript = this.app.root.children[0].script.planetInfoGenerator;
    this.uiScript = this.app.root.children[0].script.userInputHandler;
    this.sgScript = this.app.root.children[0].script.solarSystem;
    this.cam = this.app.root.findByName('Camera');
    this.camScript = this.cam.script.cameraController;
    this.specialArray = this.piScript.specialPlanet;
    this.theSeed = 0;
   // this.checkVisibility();
   // console.info(this.piScript);
};

SpecialLogos.prototype.checkVisibility = function(){
    
    this.theSeed = this.seedScript.seed;
    
    for(i = 0; i < this.entity.children.length; i++){
        this.ents[i].element.enabled = false;
    }
    
    // for(a = 0; a < this.specialArray.length; a++){
    //     if(this.specialArray[a][0] == this.theSeed){
    //         if(this.sgScript.planetCamInd == this.cam.script.cameraController.planetCounter){
    //             this.specialArray[a][4].element.enabled = true;
    //         }
    //     }
    // }
};

SpecialLogos.prototype.makeItVisible = function(makeVisible){
    for(i = 0; i < this.entity.children.length; i++){
        this.ents[i].element.enabled = false;
        if(this.ents[i] == makeVisible){
          this.ents[i].element.enabled = true;  
        }
    }
};



// update code called every frame

// swap method called for script hot-reloading
// inherit your script state here
// SpecialLogos.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

